import makeId from './makeId';
import stopLabelFromIndex from './stopLabelFormIndex';

/**
 * Create the initial shape for a checkpoint slot (formerly stop).
 * @param {number} index
 */
const emptyCheckpoint = (index) => ({
	id: makeId(index),
	label: stopLabelFromIndex(index),
	address: '',
	lat: '',
	lng: '',
	placeId: '',
	stopTimeMinutes: 0,
	timeWindowMinutes: 0,
	radiusMeters: 75,
	floor: '',
	isBadgeRequired: false,
	hasElevator: false,
	hasStairs: true,
	indoorNotes: '',
	kind: 'checkpoint',
	mode: 'DRIVING',
	// indoor: false, // Reserved for future indoor handling
});

export default emptyCheckpoint;
